import { BeSpinner, BeStack } from "@beos-css/react/index.ts";

export function SpinnerDemo() {
	return (
		<section id="demo-spinner">
			<h2>Spinner (LibWalter)</h2>
			<p>
				A numeric BTextControl (sunken white well) plus two stacked 14×14 scrollbar-style arrow buttons (white-TL / #80-BR bevel, no black
				frame — its own small button style, not a BButton). Click an arrow to step; press-and-hold auto-repeats (250ms → 150ms).
				ArrowUp/ArrowDown and typed entry (clamped) work in the field. Ported from LibWalter <code>Spinner.cpp</code>.
			</p>
			<BeStack gap="label" align="start">
				<BeSpinner label="Font size:" defaultValue={12} min={1} max={999} />
				<BeSpinner label="Count:" defaultValue={3} min={0} max={10} />
				<BeSpinner label="Disabled:" defaultValue={42} disabled />
			</BeStack>
		</section>
	);
}
